module.exports = __webpack_public_path__ + "img/main_img.20bf8141.jpg";